import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import PropTypes from "prop-types"
import Header from "./header"
import Footer from "./footer"
import "./layout.css"

const ContentWrapper = styled.div`
  margin: 0 auto;
  max-width: 800px;
  padding: 2rem 1rem;

  & main {
    min-height: 400;
  }
`

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          author
          title
          description
          social {
            name
            url
          }
        }
      }
    }
  `)

  return (
    <>
      <Header
        siteTitle={data.site.siteMetadata.title}
        description={data.site.siteMetadata.description}
        social={data.site.siteMetadata.social}
      />
      <ContentWrapper>
        <main>{children}</main>
      </ContentWrapper>
      <Footer author={data.site.siteMetadata.author} />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
